"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = exports.directions = exports.events = void 0;
var events_1 = require("events");
var Session_1 = require("ringcentral-call-control/lib/Session");
var utils_1 = require("./utils");
var events;
(function (events) {
    events["DISCONNECTED"] = "disconnected";
    events["STATUS"] = "status";
    events["RECORDINGS"] = "recordings";
    events["MUTED"] = "muted";
    events["WEBPHONE_SESSION_CONNECTED"] = "webphoneSessionConnected";
})(events = exports.events || (exports.events = {}));
;
var directions;
(function (directions) {
    directions["OUTBOUND"] = "Outbound";
    directions["INBOUND"] = "Inbound";
})(directions = exports.directions || (exports.directions = {}));
;
var Session = /** @class */ (function (_super) {
    __extends(Session, _super);
    function Session(_a) {
        var webphoneSession = _a.webphoneSession, telephonySession = _a.telephonySession;
        var _this = _super.call(this) || this;
        _this._webphoneSessionConnected = false;
        _this._onWebphoneSessionAccepted = function (incomingResponse) {
            _this._setIdsFromWebPhoneSessionHeaders(incomingResponse.headers);
            _this._status = Session_1.PartyStatusCode.answered;
        };
        _this._onWebphoneSessionProgress = function (incomingResponse) {
            _this._setIdsFromWebPhoneSessionHeaders(incomingResponse.headers);
            _this._status = Session_1.PartyStatusCode.proceeding;
        };
        _this._onWebphoneSessionTerminated = function () {
            // this._status = PartyStatusCode.disconnected;
            _this._cleanWebPhoneSession();
            if (!_this._telephonySession) {
                _this.emit(events.DISCONNECTED);
            }
        };
        _this._onTelephonyStatusChange = function (_a) {
            var party = _a.party;
            if (!_this._telephonySession) {
                return;
            }
            var myParty = _this._telephonySession.party;
            if (myParty) {
                _this._status = myParty.status.code;
            }
            _this.emit(events.STATUS, { party: party, telephonySessionId: _this.telephonySessionId, status: _this._status });
            if (myParty &&
                ((myParty.status.code === Session_1.PartyStatusCode.disconnected &&
                    myParty.status.reason !== 'Pickup' && // don't end when call switched
                    myParty.status.reason !== 'CallSwitch' // don't end when call switched
                ) ||
                    (myParty.status.code === Session_1.PartyStatusCode.gone &&
                        myParty.status.reason === 'AttendedTransfer'))) {
                _this._cleanTelephonySession();
                if (!_this._webphoneSession) {
                    _this.emit(events.DISCONNECTED);
                    return;
                }
            }
        };
        _this._onTelephonyRecordingsEvent = function (_a) {
            var party = _a.party;
            _this.emit(events.RECORDINGS, { party: party });
        };
        _this._onTelephonyMutedEvent = function (_a) {
            var party = _a.party;
            _this.emit(events.MUTED, { party: party });
        };
        _this._webphoneSession = webphoneSession;
        _this._telephonySession = telephonySession;
        _this._status = Session_1.PartyStatusCode.setup;
        if (_this._webphoneSession) {
            _this._onNewWebPhoneSession();
        }
        if (_this._telephonySession) {
            _this._onNewTelephonySession();
        }
        return _this;
    }
    Session.prototype._onNewWebPhoneSession = function () {
        if (this._webphoneSession.request) {
            this._setIdsFromWebPhoneSessionHeaders(this._webphoneSession.request.headers);
        }
        // webphone session's start time should alway replace telephony session's start time, because it counts
        // start from call was answered, so will be more accurate
        if (this._webphoneSession.startTime) {
            this._startTime = (new Date(this._webphoneSession.startTime)).getTime();
        }
        this._webphoneSession.on('accepted', this._onWebphoneSessionAccepted);
        this._webphoneSession.on('progress', this._onWebphoneSessionProgress);
        this._webphoneSession.on('terminated', this._onWebphoneSessionTerminated);
        this._webphoneSessionConnected = true;
        this.emit(events.WEBPHONE_SESSION_CONNECTED);
    };
    Session.prototype._cleanWebPhoneSession = function () {
        if (this._webphoneSession) {
            this._webphoneSession.removeListener('accepted', this._onWebphoneSessionAccepted);
            this._webphoneSession.removeListener('progress', this._onWebphoneSessionProgress);
            this._webphoneSession.removeListener('terminated', this._onWebphoneSessionTerminated);
        }
        this._webphoneSession = null;
    };
    Session.prototype._onNewTelephonySession = function () {
        this._telephonySessionId = this._telephonySession.id;
        this._sessionId = this._telephonySession.data.sessionId;
        if (this._telephonySession.party) {
            this._status = this._telephonySession.party.status.code;
        }
        if (this._telephonySession.data.creationTime && !this._startTime) {
            this._startTime = (new Date(this._telephonySession.data.creationTime)).getTime();
        }
        this._telephonySession.on(events.STATUS, this._onTelephonyStatusChange);
        this._telephonySession.on(events.RECORDINGS, this._onTelephonyRecordingsEvent);
        this._telephonySession.on(events.MUTED, this._onTelephonyMutedEvent);
    };
    Session.prototype._cleanTelephonySession = function () {
        if (this._telephonySession) {
            this._telephonySession.removeListener(events.STATUS, this._onTelephonyStatusChange);
            this._telephonySession.removeListener(events.RECORDINGS, this._onTelephonyRecordingsEvent);
            this._telephonySession.removeListener(events.MUTED, this._onTelephonyMutedEvent);
        }
        this._telephonySession = null;
    };
    Session.prototype._setIdsFromWebPhoneSessionHeaders = function (headers) {
        if (!headers) {
            return;
        }
        var _a = utils_1.extractHeadersData(headers), partyData = _a[0], callId = _a[1];
        if (partyData && partyData.sessionId) {
            this._telephonySessionId = partyData.sessionId;
        }
        if (callId) {
            this._activeCallId = callId;
        }
    };
    Session.prototype.setTelephonySession = function (telephonySession) {
        this._telephonySession = telephonySession;
        this._onNewTelephonySession();
    };
    Session.prototype.setWebphoneSession = function (webphoneSession) {
        this._webphoneSession = webphoneSession;
        this._onNewWebPhoneSession();
    };
    Session.prototype.dispose = function () {
        this._cleanTelephonySession();
        this._cleanWebPhoneSession();
        this.removeAllListeners();
    };
    Object.defineProperty(Session.prototype, "webphoneSession", {
        get: function () {
            return this._webphoneSession;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "webphoneSessionConnected", {
        get: function () {
            return this._webphoneSessionConnected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "telephonySession", {
        get: function () {
            return this._telephonySession;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "telephonySessionId", {
        get: function () {
            return this._telephonySessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "sessionId", {
        get: function () {
            return this._sessionId || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "id", {
        get: function () {
            return this._telephonySessionId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "activeCallId", {
        get: function () {
            return this._activeCallId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "direction", {
        get: function () {
            if (this.party) {
                return this.party.direction;
            }
            if (this._webphoneSession) {
                // @ts-ignore
                return this._webphoneSession.__rc_direction;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "party", {
        get: function () {
            if (!this._telephonySession) {
                return null;
            }
            return this._telephonySession.party;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "otherParties", {
        get: function () {
            if (!this._telephonySession) {
                return [];
            }
            return this._telephonySession.otherParties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "recordings", {
        get: function () {
            if (!this._telephonySession) {
                return [];
            }
            return this._telephonySession.recordings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "from", {
        get: function () {
            if (this.party) {
                return this.party.from;
            }
            if (this._webphoneSession) {
                return {
                    phoneNumber: this._webphoneSession.request.from.uri.user,
                    name: this._webphoneSession.request.from.displayName,
                };
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "to", {
        get: function () {
            if (this.party) {
                return this.party.to;
            }
            if (this._webphoneSession) {
                return {
                    phoneNumber: this._webphoneSession.request.to.uri.user,
                    name: this._webphoneSession.request.to.displayName,
                };
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "data", {
        get: function () {
            if (this._telephonySession) {
                return this._telephonySession.data;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "startTime", {
        get: function () {
            return this._startTime || null;
        },
        enumerable: false,
        configurable: true
    });
    Session.prototype.hangup = function () {
        if (this._webphoneSession) {
            return this._webphoneSession.terminate();
        }
        return this._telephonySession.drop();
    };
    Session.prototype.hold = function () {
        if (this._telephonySession) {
            return this._telephonySession.hold();
        }
        return this._webphoneSession.hold();
    };
    Session.prototype.unhold = function () {
        if (this._webphoneSession && this._webphoneSession.localHold) {
            return this._webphoneSession.unhold();
        }
        if (this._telephonySession) {
            return this._telephonySession.unhold();
        }
    };
    Session.prototype.toVoicemail = function () {
        if (this._telephonySession) {
            return this._telephonySession.toVoicemail();
        }
        return this._webphoneSession.toVoicemail();
    };
    Session.prototype.reject = function (_a) {
        var deviceId = (_a === void 0 ? {} : _a).deviceId;
        if (this._telephonySession) {
            return this._telephonySession.ignore({ deviceId: deviceId });
        }
        return this._webphoneSession.reject();
    };
    Session.prototype.answer = function (_a) {
        var deviceId = (_a === void 0 ? {} : _a).deviceId;
        if (this._webphoneSession) {
            return this._webphoneSession.accept();
        }
        return this._telephonySession.answer({ deviceId: deviceId });
    };
    Session.prototype.replyWithMessage = function (params) {
        if (this._telephonySession) {
            return this._telephonySession.reply(params);
        }
        var webphoneReplyOption = utils_1.getWebphoneReplyMessageOption(params);
        return this._webphoneSession.replyWithMessage(webphoneReplyOption);
    };
    Session.prototype.forward = function (forwardNumber, acceptOptions, transferOptions) {
        if (this._webphoneSession) {
            // @ts-ignore
            return this._webphoneSession.forward(forwardNumber, acceptOptions, transferOptions);
        }
        var params = {};
        if (forwardNumber.length > 5) {
            params.phoneNumber = forwardNumber;
        }
        else {
            params.extensionNumber = forwardNumber;
        }
        return this._telephonySession.forward(params);
    };
    Session.prototype.transfer = function (transferNumber, transferOptions) {
        if (transferOptions === void 0) { transferOptions = { type: 'phoneNumber' }; }
        if (this._telephonySession) {
            var params = {};
            if (transferOptions.type === 'phoneNumber') {
                if (transferNumber.length > 5) {
                    params.phoneNumber = transferNumber;
                }
                else {
                    params.extensionNumber = transferNumber;
                }
            }
            else {
                params[transferOptions.type] = transferNumber;
            }
            return this._telephonySession.transfer(params);
        }
        // @ts-ignore
        return this._webphoneSession.transfer(transferNumber, transferOptions);
    };
    Session.prototype.warmTransfer = function (newSession) {
        if (this._telephonySession) {
            return this._telephonySession.bridge({ telephonySessionId: newSession.telephonySessionId, partyId: newSession.party.id });
        }
        return this._webphoneSession.warmTransfer(newSession.webphoneSession);
    };
    Session.prototype.park = function () {
        if (this._webphoneSession) {
            return this._webphoneSession.park();
        }
        return this._telephonySession.park();
    };
    Session.prototype.flip = function (_a) {
        var callFlipId = _a.callFlipId;
        if (this._telephonySession) {
            return this._telephonySession.flip({ callFlipId: callFlipId });
        }
        return this._webphoneSession.flip(callFlipId);
    };
    Session.prototype.mute = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._webphoneSession) {
                    this._webphoneSession.mute();
                }
                if (this._telephonySession) {
                    return [2 /*return*/, this._telephonySession.mute()];
                }
                return [2 /*return*/];
            });
        });
    };
    Session.prototype.unmute = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._webphoneSession) {
                    this._webphoneSession.unmute();
                }
                if (this._telephonySession) {
                    return [2 /*return*/, this._telephonySession.unmute()];
                }
                return [2 /*return*/];
            });
        });
    };
    Session.prototype.startRecord = function (_a) {
        var recordingId = (_a === void 0 ? {} : _a).recordingId;
        if (this._telephonySession) {
            if (!recordingId) {
                return this._telephonySession.createRecord();
            }
            return this._telephonySession.resumeRecord(recordingId);
        }
        return this._webphoneSession.startRecord();
    };
    Session.prototype.stopRecord = function (_a) {
        var recordingId = (_a === void 0 ? {} : _a).recordingId;
        if (this._telephonySession && recordingId) {
            return this._telephonySession.pauseRecord(recordingId);
        }
        if (this._webphoneSession) {
            return this._webphoneSession.stopRecord();
        }
    };
    return Session;
}(events_1.EventEmitter));
exports.Session = Session;
//# sourceMappingURL=Session.js.map